export const isStarkey = (siteId: number) => {
    return siteId === 1;
};
